import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

import { dietsService } from '@/services/dietsService'
import { useDietsStore } from '@/store/dietsStore'

import type { DishSearchFilters } from '@/types/Diet'
import type { Nutrients } from '@/utils/nutrients'

export const useSearchDishesAndIngredients = (nutrients: Ref<Nutrients[]>) => {
  const { hasDetails } = storeToRefs(useDietsStore())

  return useQuery({
    enabled: hasDetails,
    queryFn: () => dietsService.fetchSearchDishesAndIngredients(nutrients.value),
    queryKey: ['searchDishesAndIngredients', nutrients],
    retry: 3,
    staleTime: 36000,
  })
}

export const useSearchDishesAndIngredientsSimple = (flags: Ref<DishSearchFilters | undefined>) => {
  return useQuery({
    queryFn: v =>
      dietsService.fetchSearchDishesAndIngredientsSimple(
        v.queryKey[1] ?? {
          diary_free: false,
          gluten_free: false,
          superfood: false,
          vegan: false,
          vegetarian: false,
        },
      ),
    queryKey: ['searchDishesAndIngredientsSimple', flags] as const,
    retry: 3,
    staleTime: 36000,
  })
}
